export const clientFeature = {
  AI_REVIEWS: 'ai-reviews',
};
